import { Routes } from '@angular/router';
import { AuthGuard } from '@utils/guards/auth.guard';

export const quotaRoutes: Routes = [
  {
    path: 'cuotas',
    loadComponent: () =>
      import('./quota.component').then((c) => c.QuotaComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'cuota/publica',
    loadComponent: () =>
      import('./pages/public-quota/public-quota.component').then(
        (c) => c.PublicQuotaComponent
      ),
  },
];
